// NOTE: this is applied at query factory level, not base filters level,

import { type QueryDslQueryContainer } from '@elastic/elasticsearch/lib/api/types';

// so we still need to include `query` as the top level key
export const hitRateRequiredQueryFactory = ({
	hitRateBucket = 'last10',
} = {}): QueryDslQueryContainer => ({
	bool: {
		must: [
			{
				exists: {
					field: `sportsData.hitRates.${hitRateBucket}`,
				},
			},
		],
		must_not: [
			{
				term: {
					[`sportsData.hitRates.${hitRateBucket}`]: 0,
				},
			},
		],
	},
});
